import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ruTranslations from './locales/ru.json'
import enTranslations from './locales/en.json'
import ukTranslations from './locales/uk.json'
import ptTranslations from './locales/pt.json'
import esTranslations from './locales/es.json'
import trTranslations from './locales/tr.json'
import kkTranslations from './locales/kk.json'
import uzTranslations from './locales/uz.json'
import idTranslations from './locales/id.json'

// Поддерживаемые языки
const SUPPORTED_LANGUAGES = ['ru', 'en', 'uk', 'pt', 'es', 'tr', 'kk', 'uz', 'id']

const normalizeLanguageCode = (languageCode) => {
  if (typeof languageCode !== 'string' || !languageCode.trim()) {
    return null
  }

  const normalizedLanguageCode = languageCode.toLowerCase().replace('_', '-')

  if (SUPPORTED_LANGUAGES.includes(normalizedLanguageCode)) {
    return normalizedLanguageCode
  }

  const baseLanguageCode = normalizedLanguageCode.split('-')[0]
  return SUPPORTED_LANGUAGES.includes(baseLanguageCode) ? baseLanguageCode : null
}

const getTelegramLanguage = () => {
  if (typeof window === 'undefined') {
    return null
  }

  return normalizeLanguageCode(window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code)
}

const getBrowserLanguage = () => {
  if (typeof navigator === 'undefined') {
    return null
  }

  const browserLanguages = Array.isArray(navigator.languages)
    ? navigator.languages
    : [navigator.language]

  for (const browserLanguage of browserLanguages) {
    const normalizedLanguage = normalizeLanguageCode(browserLanguage)

    if (normalizedLanguage) {
      return normalizedLanguage
    }
  }

  return null
}

const getInitialLanguage = () => {
  return getTelegramLanguage() || getBrowserLanguage() || 'ru'
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ru: {
        translation: ruTranslations
      },
      en: {
        translation: enTranslations
      },
      uk: {
        translation: ukTranslations
      },
      pt: {
        translation: ptTranslations
      },
      es: {
        translation: esTranslations
      },
      tr: {
        translation: trTranslations
      },
      kk: {
        translation: kkTranslations
      },
      uz: {
        translation: uzTranslations
      },
      id: {
        translation: idTranslations
      }
    },
    lng: getInitialLanguage(),
    fallbackLng: ['en', 'ru'],
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
